"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdDocumentationStatusLabel = exports.RdDocumentationStatus = void 0;
var RdDocumentationStatus;
(function (RdDocumentationStatus) {
    RdDocumentationStatus["COMPLETE"] = "COMPLETE";
    RdDocumentationStatus["INCOMPLETE"] = "INCOMPLETE";
    RdDocumentationStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(RdDocumentationStatus || (exports.RdDocumentationStatus = RdDocumentationStatus = {}));
exports.rdDocumentationStatusLabel = {
    [RdDocumentationStatus.COMPLETE]: 'Complete',
    [RdDocumentationStatus.INCOMPLETE]: 'Incomplete',
    [RdDocumentationStatus.NOT_APPLICABLE]: 'Not Applicable',
};
